import { ArrowLeft } from 'lucide-react';
import { ReactNode, Dispatch, SetStateAction } from 'react';
import { useNavigate } from 'react-router-dom';
import SearchBar from './SearchInput';
import BlurText from '@/animations/BlurText';
interface PageHeaderProps {
  title: string;
  icon?: ReactNode;

  showBackButton?: boolean;

  onBack?: () => void;

  rightContent?: ReactNode;

  className?: string;
  showSearch?: boolean;
  search?: string;
  setSearch?: Dispatch<SetStateAction<string>>;
}

export function PageHeader({
  title,
  icon,
  search,
  setSearch,
  showBackButton = true,

  onBack,

  rightContent,
  showSearch = false,
  className = '',
}: PageHeaderProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }

    navigate(-1);
  };
  const handleAnimationComplete = () => {};

  return (
    <div
      className={`
    relative
    grid grid-cols-[40px_1fr_40px]
    items-center
    gap-2
    w-full
    py-2
    ${className}
  `}
    >
      {/* LEFT */}
      <div className="flex justify-start">
        {showBackButton && (
          <button
            onClick={handleBack}
            className="
          flex h-9 w-9 items-center justify-center
          rounded-full
          bg-btn-gradient2
          shadow-[0_4px_18px_rgba(250,86,41,0.35)]
          transition-all duration-300
          hover:scale-105 active:scale-95
        "
            aria-label="Go back"
          >
            <ArrowLeft size={18} className="text-white" />
          </button>
        )}
      </div>

      {/* CENTER */}
      <div className="flex items-center justify-center min-w-0 px-2">
        {showSearch && search !== undefined && setSearch ? (
          <SearchBar value={search} setValue={setSearch} />
        ) : (
          title && (
            <div className="flex items-center gap-2 max-w-full">
              {icon}

              <h2 className=" text-lg capitalize text-primary-boder2">
                <BlurText
                  text={title}
                  delay={200}
                  animateBy="words"
                  direction="top"
                  onAnimationComplete={handleAnimationComplete}
                  className="text-lg"
                />
              </h2>
            </div>
          )
        )}
      </div>

      {/* RIGHT */}
      <div className="flex justify-end">{rightContent}</div>
    </div>
  );
}
